import styled from '@emotion/styled'
import { InfoSmall500Style } from '../../../../../styles/Text.styles'
import theme from '../../../../../styles/theme'
import { RunButtonWithIcon } from '../../../../ui_reusable/styles/Button.styles'

export const RunModelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const ButtonsWrapperWithNote = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: end;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`

export const RunButtonWithIconWrapper = styled(RunButtonWithIcon)`
  padding-top: 16px;
  padding-right: 28px;
  padding-bottom: 16px;
  padding-left: 28px;
`

export const ErrorSectionLabel = styled.div<{
  isFirst?: boolean
}>`
  ${InfoSmall500Style};
  font-weight: bold;
  color: ${theme.colors.error};
  margin-top: ${(props) => (props.isFirst ? '0' : '10px')};
`

export const ErrorSectionList = styled.ul`
  margin-top: 5px;
  margin-bottom: 0;
`

export const ErrorSummary = styled.div`
  padding: 1.4rem;
  border: 1px solid ${theme.colors.error};
  border-radius: 1rem;
  background-color: ${theme.colors.surface};
  h4 {
    color: ${theme.colors.error};
    margin-bottom: 0.5rem;
  }

  ul {
    margin: 0;
    padding-left: 1.5rem;
    color: ${theme.colors.error};
  }
`
